export enum DataHooks {
  Title = 'section-header-title',
  Divider = 'section-header-divider',
}
